var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000005604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.174099 0.109196C0.397165 -0.0424889 0.74878 -0.0352557 0.959453 0.125352L10 7.01744L19.0406 0.125352C19.2512 -0.0352557 19.6028 -0.0424889 19.8259 0.109196C20.049 0.26088 20.059 0.514043 19.8483 0.67465L10.4039 7.87465C10.2989 7.95466 10.1528 8 10 8C9.84715 8 9.70105 7.95466 9.5961 7.87465L0.151661 0.67465C-0.0590124 0.514043 -0.0489662 0.26088 0.174099 0.109196Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.174099 6.1092C0.397165 5.95751 0.74878 5.96474 0.959453 6.12535L10 13.0174L19.0406 6.12535C19.2512 5.96474 19.6028 5.95751 19.8259 6.1092C20.049 6.26088 20.059 6.51404 19.8483 6.67465L10.4039 13.8747C10.2989 13.9547 10.1528 14 10 14C9.84715 14 9.70105 13.9547 9.5961 13.8747L0.151661 6.67465C-0.0590124 6.51404 -0.0489662 6.26088 0.174099 6.1092Z",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll_down.3e0d3399a70b87a155cc90444c6bf0be.svg";
export { ForwardRef as ReactComponent };